import { useMutation } from "@tanstack/react-query"
import axios from "axios"
import { DataResponse, SizeChartGenerateImageResponseData } from "schema"
import { z } from "zod"

export const FrontendGenerateSizeChartImageSchema = z.object({
  document: z.instanceof(FileList).refine((value) => value.length > 0, { message: "Required" }),
  variables: z.array(z.string()).min(1, { message: "Required" }),
})

export type GenerateSizeChartImagePayload = z.infer<typeof FrontendGenerateSizeChartImageSchema>

type Response = DataResponse<z.infer<typeof SizeChartGenerateImageResponseData>>

export function useShopifyGenerateSizeChartImageMutation() {
  return useMutation({
    mutationFn: async (data: GenerateSizeChartImagePayload) => {
      const formData = new FormData()
      const file = data.document[0]

      if (file) {
        formData.append("file", file)
      }

      data.variables.forEach((variable) => {
        formData.append("variables", variable)
      })

      return axios
        .post<Response>("/integrations/shopify/size-chart/generate-image", formData)
        .then((response) => response.data.data)
    },
  })
}
